// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#removeBrModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#removeBrModal .disabledDelete {
  opacity: 0.3;
}
#removeBrModal .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
#removeBrModal {
  /* Create a custom checkbox */
}
#removeBrModal .checkmark {
  position: absolute;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
#removeBrModal label {
  font-size: 1.6rem !important;
}
#removeBrModal {
  /* When the checkbox is checked, add a blue background */
}
#removeBrModal .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
#removeBrModal {
  /* Create the checkmark/indicator (hidden when not checked) */
}
#removeBrModal .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
#removeBrModal {
  /* Show the checkmark when checked */
}
#removeBrModal .container input:checked ~ .checkmark:after {
  display: block;
}
#removeBrModal {
  /* Style the checkmark/indicator */
}
#removeBrModal .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
#removeBrModal .container.radio {
  width: fit-content !important;
  padding: 0 50px;
}
#removeBrModal .checkmark {
  margin-left: -26px;
  margin-top: 3px;
}
#removeBrModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#removeBrModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#removeBrModal .btn-link:focus {
  text-decoration: none;
}
#removeBrModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#removeBrModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#removeBrModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#removeBrModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#removeBrModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#removeBrModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#removeBrModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#removeBrModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
